<div class="border-card border-0 px-4 py-1 overflow-auto">
     <NavigationBackButton />
      <!-- Applicant Overview Card -->
        <div class="card card-nav-tabs mt-5 rounded-lg border-0 shadow">
            <div class="card-header card-header-primary text-white shadow rounded-lg p-2">
                <p class="text-dark mt-2 ms-2 text-x" >Applicant Transition Overview</p>
            </div>

            <div class="card-body rounded-lg shadow p-3">
                <div class="card mb-4 shadow rounded-lg">
                    <div class="card-body">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <p class="text-dark text-xxs mb-0 fw-bold">Applicant Overview</p>
                    </div>
                    
                    <div class="row g-4">
                        <!-- Row 1 -->
                        <div class="col-md-4">
                        <div class="d-flex align-items-start">
                            <div class="rounded-circle bg-secondary me-2"></div>
                            <div>
                            <div class="text-muted text-xxs">Full Name</div>
                            <div class="text-xs">John Doe</div>
                            </div>
                        </div>
                        </div>
                        
                        <div class="col-md-4">
                        <div class="d-flex align-items-start">
                            <div class="rounded-circle bg-secondary me-2"></div>
                            <div>
                            <div class="text-muted text-xxs">Email Address</div>
                            <div class="text-xs">johndoe@email.com</div>
                            </div>
                        </div>
                        </div>
                        
                        <div class="col-md-4">
                        <div class="d-flex align-items-start">
                            <div class="rounded-circle bg-secondary me-2"></div>
                            <div>
                            <div class="text-muted text-xxs">Date Reviewed</div>
                            <div class="text-xs">12 June 2025</div>
                            </div>
                        </div>
                        </div>
                        
                        <!-- Row 2 -->
                        <div class="col-md-4">
                        <div class="d-flex align-items-start">
                            <div class="rounded-circle bg-success me-2"></div>
                            <div>
                            <div class="text-muted text-xxs">Review Outcome</div>
                            <div class="text-xs text-primary-green"><i class="fa-solid fa-check-double fs-6 text-primary-green me-2"></i>Approved</div>
                            </div>
                        </div>
                        </div>
                        
                        <div class="col-md-4">
                        <div class="d-flex align-items-start">
                            <div class="rounded-circle bg-secondary me-2"></div>
                            <div>
                            <div class="text-muted text-xxs">Associated Forms</div>
                            <div class="text-xs">KYC Form, Entity Application Form</div>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>

                <!-- Step 1: Review Summary -->
                <div class="card mb-4 shadow rounded-lg">
                    <div class="card-body">
                    <p class="text-xxs text-dark mb-3 fw-bold">Review Summary</p>
                    <div class="bg-opacity-10 border border-success border-opacity-25 rounded p-3">
                        <div class="d-flex align-items-center mb-2">
                        <span class="me-2"><i class="fa-solid fa-check-double fs-6 text-primary-green"></i></span>
                        <span class="text-xs">Decision: Approved</span>
                        </div>
                        <div class="text-dark text-xxs ms-4 mb-1">
                        Comments : "Meets all eligibility and compliance requirements."
                        </div>
                        <div class="text-dark text-xxs ms-4">
                        Documents : 
                        <a href="#" class="text-blue text-decoration-underline">ID Copy</a>
                        <span class="text-muted mx-1">•</span>
                        <a href="#" class="text-blue text-decoration-underline">Proof of Address</a>
                        </div>
                    </div>
                    </div>
                </div>

                <!-- Step 2: Entity Profile Setup -->
                <div class="card mb-4 shadow rounded-lg">
                    <div class="card-body">
                    <p class="text-xxs fw-bold text-dark mb-3">Trust Profile</p>
                    
                    <div class="row g-3">
                        <!-- Row 1 -->
                        <div class="col-md-6">
                        <label class="form-label text-xxs text-body-secondary">Trust Name</label>
                        <div class="form-control bg-white text-xxs">
                            John Doe
                        </div>
                        </div>
                        
                        <div class="col-md-6">
                        <label class="form-label text-xxs text-body-secondary">Trust Type</label>
                        <div class="form-control text-xxs bg-white">
                            Individual
                        </div>
                        </div>
                        
                        <!-- Row 2 -->
                        <div class="col-md-6">
                        <label class="form-label text-xxs text-body-secondary">Region</label>
                        <div class="form-control text-xxs bg-white">
                            North America
                        </div>
                        </div>
                        
                        <div class="col-md-6">
                        <label class="form-label text-xxs text-body-secondary">Trust Category</label>
                        <div class="form-control text-xxs bg-white">
                            Standard
                        </div>
                        </div>
                        
                        <!-- Auto-generate checkbox -->
                        <div class="col-12">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="autoGenerate" checked>
                            <label class="form-check-label text-xxs" for="autoGenerate">
                            Auto-generate Trust ID
                            </label>
                        </div>
                        </div>
                        
                        <!-- Advanced Options -->
                        <div class="col-12">
                        <hr class="my-3">
                        <div class="bg-light border rounded p-3 mt-2">
                            <div class="row g-3">
                            <div class="col-md-6">
                                <label class="form-label text-xxs">Set Default Status</label>
                                <div class="form-control text-xxs bg-white">
                                Active
                                </div>
                            </div>
                            
                            <div class="col-md-6">
                                <label class="form-label text-xxs">Link to Existing Trust Cluster</label>
                                <div class="form-control text-xxs bg-white text-body-tertiary">
                                Enter cluster ID
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>

                <!-- Step 3: Assign Workflows & Services -->
                <div class="card mb-4 shadow rounded-lg">
                    <div class="card-body">
                    <p class="text-xxs fw-bold text-dark mb-3">Assign Initial Setup</p>
                    
                    <div class="row">
                        <!-- Workflows Column -->
                        <div class="col-md-6">
                        <label class="form-label text-xxs">Available Workflows</label>
                        
                        <div class="form-check mb-2">
                            <input class="form-check-input" type="checkbox" id="onboarding" checked>
                            <label class="form-check-label text-xxs" for="onboarding">Onboarding</label>
                        </div>
                        
                        <div class="form-check mb-2">
                            <input class="form-check-input" type="checkbox" id="monitoring">
                            <label class="form-check-label text-xxs" for="monitoring">Monitoring</label>
                        </div>
                        
                        <div class="form-check mb-2">
                            <input class="form-check-input" type="checkbox" id="periodicReview">
                            <label class="form-check-label text-xxs" for="periodicReview">Periodic Review</label>
                        </div>
                        
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="complianceChecks" checked>
                            <label class="form-check-label text-xxs" for="complianceChecks">Compliance Checks</label>
                        </div>
                        </div>
                        
                        <!-- Services Column -->
                        <div class="col-md-6">
                        <label class="form-label text-xxs">Default Services</label>
                        
                        <div class="form-check mb-2">
                            <input class="form-check-input" type="checkbox" id="serviceCompliance" checked>
                            <label class="form-check-label text-xxs" for="serviceCompliance">Compliance Checks</label>
                        </div>
                        
                        <div class="form-check mb-2">
                            <input class="form-check-input" type="checkbox" id="notificationService" checked>
                            <label class="form-check-label text-xxs" for="notificationService">Notification Service</label>
                        </div>
                        
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="documentVault" checked>
                            <label class="form-check-label text-xxs" for="documentVault">Document Vault</label>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>

            </div>
        </div>    
  </div>